module.exports = __webpack_public_path__ + "static/media/IMG_5374.6efbc646.JPG";